import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.toggle()
  }

  toggle() {
    const selected = document.querySelector('input[name="purchase_backskin[media_type]"]:checked')?.value

    const videoBox = document.getElementById("video-wrapper") || document.getElementById("video_edit")
    const imageBox = document.getElementById("image-wrapper")

    if (!selected) return

    if (selected === "Static") {
      videoBox?.classList.add("d-none")
      imageBox?.classList.remove("d-none")
    } else {
      imageBox?.classList.add("d-none")
      videoBox?.classList.remove("d-none")
    }
  }
}
